// Input: Date object
// Output: "Monday, Jan 1, 2024"
export function getFormattedDate(date = new Date()) {
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

// Input: Date object
// Output: "2024-01-01"
export const formatDateToYearMonthDayString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Input: "YYY-mm-dd"
// Output: "Nov 11, 2025"
export const formatYMDToLongDateString = (dateString: Date) => {
  const fmt = new Intl.DateTimeFormat('en-US', {
    'year': 'numeric',
    'month': 'short',
    'day': 'numeric',
  });

  const date = new Date(dateString + 'T00:00');

  return fmt.format(date);
};

// Input: Date object
// Output: "Dec 10, 6:30 pm"
export const getConciseDateTime = (date = new Date()) => {
  return date.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};

// Returns `count` consecutive Mon–Fri dates as YYYY-MM-DD strings, starting from `startDate`.
// Used by MSW mocks and any caller that needs weekday-spaced tick data.
export const weekdaysFrom = (startDate: string | Date, count: number): string[] => {
  const ticks: string[] = [];
  const d = new Date(startDate);
  while (ticks.length < count) {
    const day = d.getDay();
    if (day !== 0 && day !== 6) ticks.push(formatDateToYearMonthDayString(d));
    d.setDate(d.getDate() + 1);
  }
  return ticks;
};

// Returns `count` dates spaced one week apart as YYYY-MM-DD strings, starting from `startDate`.
export const weeksFrom = (startDate: string | Date, count: number): string[] => {
  const ticks: string[] = [];
  const d = new Date(startDate);
  for (let i = 0; i < count; i++) {
    ticks.push(formatDateToYearMonthDayString(d));
    d.setDate(d.getDate() + 7);
  }
  return ticks;
};

// Returns `count` dates spaced one month apart as YYYY-MM-DD strings, starting from `startDate`.
export const monthsFrom = (startDate: string | Date, count: number): string[] => {
  const ticks: string[] = [];
  const d = new Date(startDate);
  for (let i = 0; i < count; i++) {
    ticks.push(formatDateToYearMonthDayString(d));
    d.setMonth(d.getMonth() + 1);
  }
  return ticks;
};
